(function (ws) {
    'use strict';
    ws.models.resetPassword = Backbone.Model.extend({
        urlRoot: globals.path.api.westcon.resetPasswordRequest,
        defaults: {
            email: ''
        }
    });
})(westcon);
